export default __webpack_public_path__ + "static/media/ic-art-drink-apple.12c64798.svg";